import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { addToPlaylistSlice } from '../../reducers'

const SKILL_BITE_SESSION_READ_TIME_MINUTES = 15

const toPlaylistItem = (item) => {
  if (!item?.skillBiteId) return item

  const sessionCount = item.sessionCount ?? item.sessions?.length
  const readTime = item.readTime ?? (sessionCount != null
    ? sessionCount * SKILL_BITE_SESSION_READ_TIME_MINUTES
    : undefined)

  const sk = item.sk || `skill-bite#${item.skillBiteId}`

  return {
    ...item,
    sk,
    friendlyUrl: item.friendlyUrl || sk,
    title: item.title || item.name,
    primaryType: item.primaryType || ['skill-bite'],
    ...(sessionCount != null && { sessionCount }),
    ...(readTime != null && { readTime })
  }
}

const useAddToPlaylist = () => {
  const dispatch = useDispatch()

  const [article, setArticle] = useState()

  const showAddToPlaylist = article => {
    setArticle(toPlaylistItem(article))
    dispatch(addToPlaylistSlice.actions.showDialog(true))
  }

  const getPlaylistArticle = useCallback(() => article, [article])

  return { showAddToPlaylist, getPlaylistArticle }
}

export default useAddToPlaylist
